export default __webpack_public_path__ + "static/media/aidistrict.2497acc8.jpg";